import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your Firebase config - replace with your actual config from Firebase Console
const firebaseConfig = {
  apiKey: "AIzaSyDZqi_3M-9Eg0MF5M4eJ8uE9M4bAb9xcyU",
  authDomain: "arcrefinery-3bbda.firebaseapp.com",
  projectId: "arcrefinery-3bbda",
  storageBucket: "arcrefinery-3bbda.firebasestorage.app",
  messagingSenderId: "8000581211",
  appId: "1:8000581211:web:1886d1844fad7cf59e997e",
  measurementId: "G-83EZX02CV9"
};



// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

export default app;
